import { useState, useEffect } from "react";
import { getCurrentMailItem, onItemChanged, OutlookMailItem } from "../services/outlookService";

export function useOutlookItem() {
  const [currentItem, setCurrentItem] = useState<OutlookMailItem | null>(null);
  const [loading, setLoading] = useState(true);

  const loadItem = async () => {
    setLoading(true);
    const item = await getCurrentMailItem();
    setCurrentItem(item);
    setLoading(false);
  };

  useEffect(() => {
    loadItem();
    onItemChanged(() => loadItem());
  }, []);

  return { currentItem, loading, reload: loadItem };
}
